/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Step/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Account from './Account/index'
import Doctor from './Doctor/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Step({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CreateIteroScanRequest/Content/Content/Step"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Account'
let selectedStepValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'step',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedStepValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Account'}>
<Account
  viewPath={`${viewPath}/Account`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Doctor'}>
<Doctor
  viewPath={`${viewPath}/Doctor`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}